import * as perlinModule from './perlin'

// Singleton access.
export const perlin = perlinModule.create()

// For those that need to create and configure their own instances.
export const factories = {
  perlin: perlinModule.create
}
